module.exports = __webpack_public_path__ + "static/4-b2ec40130389c0f7531833aca8d47d12.png";